/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';

import { Container } from './styles';
import api from '~/services/api';
import { Col, Row } from 'react-bootstrap';
import { useLinkMaterial } from '~/hooks/useLinkMaterial';

interface FormDefaultProps {
  codTela: number;
}

const FooterDefault: React.FC<FormDefaultProps> = (props) => {
  const { children, codTela } = props;
  const { data } = useLinkMaterial(codTela);

  return (
    <Container>
      <Row className="rowContainerFooter">
        <Col sm={12} md={9} className="containerChild">
          {children}
        </Col>
        <Col className="containerTitle" sm={12} md={3}>
          {data ? (
            <div className="containerMaterial">
              <a href={data} target="_blank" className="linkMaterial">
                Precisa de ajuda?
              </a>
            </div>
          ) : (
            <div style={{ display: 'hidden' }} />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default FooterDefault;
